export default __webpack_public_path__ + "static/media/logo-login.36f872b4.svg";